import ListsComponent from 'component/Survey/Create/Logic/Jump/Lists/Component'

function ListsContainer() {
    return <ListsComponent/>
}

export default ListsContainer